var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHederaHashgraphHbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 560,
    viewBox: "0 0 560 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280 0C125.359 0 0 125.359 0 280C0 434.641 125.359 560 280 560C434.641 560 560 434.641 560 280C560 125.359 434.641 0 280 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.819 401.099H358.261V325.501H201.739V401.099H166.179V155.96H201.739V229.739H358.261V155.96H393.821L393.819 401.099ZM203.419 297.219H359.939V258.16H203.419V297.219Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 560,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHederaHashgraphHbar);
export default __webpack_public_path__ + "static/media/hedera-hashgraph-hbar.5e0856a1cf0b957184b0b9dd9aae72ef.svg";
export { ForwardRef as ReactComponent };